export default __webpack_public_path__ + "static/media/39_1_4.89a2c48e.png";